export enum SCHEDULE_TYPE {
    initialTerm,
    operate,
    build,
}

export enum SOURCE_TYPE {
    capitalRatio,
    borrowingRate,
    predeterminedNumber,
    loanTerm,
    periodGrace,
    repayment,
}

export enum ASSETS_TYPE {
    fixedAssetsRatio,
    residualRrate,
    depreciationPeriod,
    reimbursementPeriod,
}

export enum PRODUCTION_COST_TYPE {
    capacity,
    annualSalary,
    welfareFactor,
    insuranceRate,
    materialsExpenses,
    otherExpenses,
}

export enum CHARGE_TYPE {
    workingCapitalLoanRatio,
    interestRateAndWorkingCapital,
    annualAPCirculationTimes,
    annualStockCirculationTimes,
    annualCashCirculationTimes,
    annualARCirculationTimes,
}

export enum ANALYSIS_TYPE {
    electricityVATRate,
    steamSaleVATRate,
    hotColdVATRate,
    fuelBoughtVATRate,
    materialBoughtVATRate,
    legalAccumulationFundRate,
    aleatoricAccumulationFundRate,
    cityMaintenanceConstructionTaxTate,
    educationFeePlus,
    localEducationPlus,
    corporateIncomeTaxRate,
    basicDiscountRate,
}

export enum SCHEDULE_TYPE_TO_DATA {
    '项目起始年限' = 'initialTerm',
    '项目建设期（年）' = 'build',
    '项目运营期（年）' = 'operate',
}

export enum SOURCE_TYPE_TO_DATA {
    '资本金比例(%)' = 'capitalRatio',
    '借款年利率(%)' = 'borrowingRate',
    '贷款年限' = 'loanTerm',
    '宽限期(年)' = 'periodGrace',
    '计息次数' = 'predeterminedNumber',
    '还款方式' = 'repayment',
}

export enum ASSETS_TYPE_TO_DATA {
    '固定资产比例(%)' = 'fixedAssetsRatio',
    '残值(%)' = 'residualRrate',
    '折旧年限' = 'depreciationPeriod',
    '摊销年限' = 'reimbursementPeriod',
}

export enum PRODUCTION_COST_TYPE_TO_DATA {
    '定员(人)' = 'capacity',
    '工资(万元/(人·年))' = 'annualSalary',
    '福利系数(%)' = 'welfareFactor',
    '保险费率(%)' = 'insuranceRate',
    '材料费(万元/年)' = 'materialsExpenses',
    '其他费用(万元/年)' = 'otherExpenses',
}

export enum CHARGE_TYPE_TO_DATA {
    '流动资金贷款比例(%)' = 'workingCapitalLoanRatio',
    '短期贷款及流动资金利率(%)' = 'interestRateAndWorkingCapital',
    '应收账款年周转次数' = 'annualAPCirculationTimes',
    '存货年周转次数' = 'annualStockCirculationTimes',
    '现金年周转次数' = 'annualCashCirculationTimes',
    '应付账款年周转次数' = 'annualARCirculationTimes',
}

export enum ANALYSIS_TYPE_TO_DATA {
    '售电增值税税率%' = 'electricityVATRate',
    '售汽增值税率%' = 'steamSaleVATRate',
    '售冷热增值税税率%' = 'hotColdVATRate',
    '燃料增值税税率%' = 'fuelBoughtVATRate',
    '材料费进项增值税率%' = 'materialBoughtVATRate',
    '法定公积金率%' = 'legalAccumulationFundRate',
    '任意公积金率%' = 'aleatoricAccumulationFundRate',
    '城市维护建设税税率%' = 'cityMaintenanceConstructionTaxTate',
    '教育费附加%' = 'educationFeePlus',
    '地方教育附加%' = 'localEducationPlus',
    '企业所得税税率%' = 'corporateIncomeTaxRate',
    '基准折现率%' = 'basicDiscountRate',
}
